// extracted by mini-css-extract-plugin
module.exports = {"box":"_53x7N","cover":"_2cNnh","city":"tL-Tg"};